import en from './locales/en';
import fr from './locales/fr';
import es from './locales/es';
import ru from './locales/ru';
import ht from './locales/ht';
import { detectLanguageFromCountry, resolveVisitorCountry } from './geo';

export const translations = { en, fr, es, ru, ht };

export const LANGUAGE_OPTIONS = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'ht', name: 'Kreyòl', flag: '🇭🇹' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
];

export const SUPPORTED_LANGUAGES = LANGUAGE_OPTIONS.map((lang) => lang.code);

const isSupportedLanguage = (code) => SUPPORTED_LANGUAGES.includes(code);

export const hasManualLanguagePreference = () => {
  try {
    return localStorage.getItem('languageManual') === '1';
  } catch {
    return false;
  }
};

export const markLanguagePreferenceManual = (code) => {
  try {
    localStorage.setItem('languageManual', '1');
    localStorage.setItem('language', code);
  } catch {
    // ignore
  }
};

export const detectBrowserLanguage = () => {
  const candidates = [];
  if (typeof navigator !== 'undefined') {
    if (navigator.language) candidates.push(navigator.language);
    if (Array.isArray(navigator.languages)) candidates.push(...navigator.languages);
  }
  for (const raw of candidates) {
    const code = String(raw || '').split('-')[0].toLowerCase();
    if (code === 'ht' || String(raw || '').toLowerCase().includes('-ht')) return 'ht';
    if (isSupportedLanguage(code)) return code;
  }
  return 'en';
};

export const getInitialLanguage = (options = {}) => {
  if (hasManualLanguagePreference()) {
    try {
      const saved = localStorage.getItem('language');
      if (isSupportedLanguage(saved)) return saved;
    } catch {
      // ignore storage errors
    }
  }
  const country = resolveVisitorCountry(options);
  const fromCountry = country ? detectLanguageFromCountry(country) : null;
  if (fromCountry && isSupportedLanguage(fromCountry)) return fromCountry;
  return detectBrowserLanguage();
};

export const getDateLocale = (language) => {
  switch (language) {
    case 'ht':
      return 'fr-HT';
    case 'fr':
      return 'fr-FR';
    case 'es':
      return 'es-ES';
    case 'ru':
      return 'ru-RU';
    default:
      return 'en-US';
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
